import { useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";


const Settings = () => {
    // const { user } = useAuth();
    const [phone, setPhone] = useState("+11234567890"); 

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!phone || phone.length < 10) {
            alert("Please enter a valid phone number.");
            return;
        }
    };

  return (
    <div className="block p-6 bg-[#ffffff] rounded-lg shadow-sm">
        <h1 className="text-center font-sans text-[28px] text-[#181D27] leading-9">Update Profile Settings</h1>
        <p className="font-['Open Sans'] text-center font-normal text-[14px] leading-4 text-[#535862] mb-4">After changing click “Save”</p>
        
        <div className="container-sm mt-6">
            <div className="flex items-center justify-between mb-12">
                <div>
                    <h2 className="text-[#0575E6] text-[30px] font-sans leading-5 text-lg font-semibold">Current Plan</h2>
                    <a href="#" className="text-[#5B5B5B] text-[16px] leading-4 underline text-sm">Upgrade now</a>
                </div>
                <button className="bg-[#0575E6] text-[#ffffff] border px-10 py-2 rounded-md text-sm hover:bg-[#ffffff] hover:text-[#0575E6] hover:border hover:border-[#0575E6] transition">Free</button>
            </div>
            
            <form className="space-y-6" onSubmit={handleSubmit}>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                        <label className="block text-sm font-medium text-[#5B5B5B] mb-1">First Name</label>
                        <input type="text" placeholder="" className="w-full p-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-[#5B5B5B] mb-1">Last Name</label>
                        <input type="text" placeholder="" className="w-full p-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" />
                    </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                        <label className="block text-sm font-medium text-[#5B5B5B] mb-1">Email</label>
                        <input type="email" placeholder="" className="w-full p-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-[#5B5B5B] mb-1">Phone Number</label>
                        <PhoneInput
                            country={"us"}
                            value={phone}
                            onChange={(phone) => setPhone(phone)}
                            inputProps={{
                                required: true,
                                autoFocus: true
                            }}
                            inputClass="!w-full !p-6 !pl-12 !border !rounded-md !bg-white !text-gray-700 focus:!outline-none focus:!ring-2 focus:!ring-blue-500"
                            containerClass="!w-full "
                            buttonClass="!bg-gray-100 !border-r !rounded-md !border-gray-300"
                        />
                    </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                        <label className="block text-sm font-medium text-[#5B5B5B] mb-1">Time Zone</label>
                        <select className="w-full p-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
                            <option>05:00pm (GMT+1)</option>
                            <option>GMT</option>
                            <option>PST</option>
                            <option>EST</option>
                        </select>
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-[#5B5B5B] mb-1">Select Language</label>
                        <select className="w-full p-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
                            <option>Dutch (Default)</option>
                            <option>English</option>
                        </select>
                    </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                        <label className="block text-sm font-medium text-[#5B5B5B] mb-1">Change Password</label>
                        <input type="password" placeholder="" className="w-full p-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-[#5B5B5B] mb-1">Preferred Coach</label>
                        <select className="w-full p-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
                            <option value="female">Female</option>
                            <option value="male">Male</option>
                        </select>
                    </div>
                </div>

                <div>
                    <button className="border px-4 py-2 rounded-md text-sm text-[#0575E6] border-[#0575E6] hover:bg-[#0575E6] hover:text-white transition float-right">Browse plan’s</button>
                    <h2 className="text-[#0575E6] text-xl font-normal">Subscriptions</h2>
                    <p className="py-3">You have no active subscriptions.</p>
                </div>
                <div>
                    <button className="float-right border px-4 py-2 rounded-md text-sm text-[#0575E6] border-[#0575E6] hover:bg-[#0575E6] hover:text-white transition">Add payment method</button>
                    <h2 className="text-[#0575E6] text-xl font-normal">Payment Method</h2>
                    <p className="py-3">No saved methods found.</p>
                </div>
                <div>
                    <button className="float-right border px-4 py-2 rounded-md text-sm text-[#0575E6] border-[#0575E6] hover:bg-[#0575E6] hover:text-white transition">Add address</button>
                    <h2 className="text-[#0575E6] text-xl font-normal">Billing Address</h2>
                    <p className="py-3">You have not set up this type of address yet.</p>
                </div>
                
                <div className="flex justify-end">
                    <button type="submit" className="bg-[#0575E6] mt-6 text-[#ffffff] border px-10 py-2 rounded-md text-sm hover:bg-[#ffffff] hover:text-[#0575E6] hover:border hover:border-[#0575E6] transition">Save</button>
                </div>
            </form>
        </div>
    </div>
  );
};

export default Settings;

